import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const auth = (token) => (token ? { headers: { Authorization: `Bearer ${token}` } } : {});

export const api = {
  state: () => axios.get(`${API}/state`).then((r) => r.data),
  setAvailability: (playerId, weekId, status, token) =>
    axios.post(`${API}/availability`, { playerId, weekId, status }, auth(token)).then((r) => r.data),
  verifyPin: (pin) => axios.post(`${API}/captain/verify`, { pin }).then((r) => r.data),
  addPlayer: (name, token) => axios.post(`${API}/players`, { name }, auth(token)).then((r) => r.data),
  editPlayer: (id, name, token) => axios.put(`${API}/players/${id}`, { name }, auth(token)).then((r) => r.data),
  addWeek: (week, token) => axios.post(`${API}/weeks`, week, auth(token)).then((r) => r.data),
  editWeek: (id, week, token) => axios.put(`${API}/weeks/${id}`, week, auth(token)).then((r) => r.data),
  setTeamName: (name, token) => axios.put(`${API}/team-name`, { name }, auth(token)).then((r) => r.data),
  backup: (token) => axios.get(`${API}/backup`, auth(token)).then((r) => r.data),
  restore: (data, token) => axios.post(`${API}/restore`, { data }, auth(token)).then((r) => r.data),
};

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d?.msg || d);
}
